export function transformUserSecurity(usersecurity) {
  return {
    enabled2fa: usersecurity.enabled2fa,
    twoFactorAuthenticationType: usersecurity.twoFactorAuthenticationType,
    lockUserAccount: usersecurity.lockUserAccount,
    loginAttempts: usersecurity.loginAttempts,
    sessionIdleTimeOutUnit: usersecurity.sessionIdleTimeOutUnit,
    sessionTimeOutUnit: usersecurity.sessionTimeOutUnit,
    enbleSessionTimeout: usersecurity.enbleSessionTimeout,
    sessionIdleTimeOut: usersecurity.sessionIdleTimeOut,
    sessionTimeOut: usersecurity.sessionTimeOut,
    disabledConcurrentLoggedIn: usersecurity.disabledConcurrentLoggedIn,
    enableCaptcha: usersecurity.enableCaptcha,
    captchaType: usersecurity.captchaType,
    enabledForgotPassword: usersecurity.enabledForgotPassword,
    site: usersecurity.site,
    secret: usersecurity.secret,
    captchaEnableModules: usersecurity.captchaEnableModules,
    enabledGoogleLogin: usersecurity.enabledGoogleLogin,
    googleWebClientId: usersecurity.googleWebClientId,
    googleAndroidClientId: usersecurity.googleAndroidClientId,
    googleIosClientId: usersecurity.googleIosClientId,
    googleAndroidPackageId: usersecurity.googleAndroidPackageId,
    googleAndroidSHA1CirtificateFingerPrint:
      usersecurity.googleAndroidSHA1CirtificateFingerPrint,
    googleIosBundelId: usersecurity.googleIosBundelId,
    googleIosAppleId: usersecurity.googleIosAppleId,
    googleIosTeamId: usersecurity.googleIosTeamId,
    proxyConfigId: usersecurity.proxyConfigId,
    loginMethod: usersecurity.loginMethod,
  }
}

export function transformUserSecurityForServer(usersecurity) {
  return {
    enabled2fa: usersecurity.enabled2fa,
    twoFactorAuthenticationType: usersecurity.twoFactorAuthenticationType,
    lockUserAccount: usersecurity.lockUserAccount,
    loginAttempts: usersecurity.loginAttempts,
    sessionIdleTimeOutUnit: usersecurity.sessionIdleTimeOutUnit,
    sessionTimeOutUnit: usersecurity.sessionTimeOutUnit,
    enbleSessionTimeout: usersecurity.enbleSessionTimeout,
    sessionIdleTimeOut: usersecurity.sessionIdleTimeOut,
    sessionTimeOut: usersecurity.sessionTimeOut,
    disabledConcurrentLoggedIn: usersecurity.disabledConcurrentLoggedIn,
    enableCaptcha: usersecurity.enableCaptcha,
    captchaType: usersecurity.captchaType,
    enabledForgotPassword: usersecurity.enabledForgotPassword,
    site: usersecurity.site,
    secret: usersecurity.secret,
    captchaEnableModules: usersecurity.captchaEnableModules,
    enabledGoogleLogin: usersecurity.enabledGoogleLogin,
    googleWebClientId: usersecurity.googleWebClientId,
    googleAndroidClientId: usersecurity.googleAndroidClientId,
    googleIosClientId: usersecurity.googleIosClientId,
    googleAndroidPackageId: usersecurity.googleAndroidPackageId,
    googleAndroidSHA1CirtificateFingerPrint:
      usersecurity.googleAndroidSHA1CirtificateFingerPrint,
    googleIosBundelId: usersecurity.googleIosBundelId,
    googleIosAppleId: usersecurity.googleIosAppleId,
    googleIosTeamId: usersecurity.googleIosTeamId,
    proxyConfigId: usersecurity.proxyConfigId,
    loginMethod: usersecurity.loginMethod,
  }
}
